import { EnvelopeIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { toast } from "react-toastify";
import { apiRequest } from "src/async/apiUtils";
import Button from "src/components/form/Button";
import Input from "src/components/form/Input";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import { useSiteSettings } from "src/context/SiteSettingsContext";
import { useAsyncAction } from "src/hooks/useAsyncAction";
import AuthDataLayout from "src/layouts/AuthDataLayout";

const ForgotPassword = () => {
  const { loading, site } = useSiteSettings();

  const [email, setEmail] = useState("");

  const {
    loading: verifiingUser,
    success: userVerified,
    execute: verifyUser,
  } = useAsyncAction({
    onSuccess: (res) => {
      const resData = res.data;
      if (resData.status === 200) {
        setEmail("");
      } else {
        toast.error(resData.message);
      }
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  const onSubmit = () => {
    verifyUser(async () => {
      return await apiRequest("post", "/portal/verify-user", {
        body: { email },
      });
    });
  };

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Preloader />
      </div>
    );
  }

  const LinkUpComponent = () => (
    <div className="mt-4">
      <div className="flex justify-center space-x-2 font-medium">
        <span>Return to</span>
        <Button
          buttonClasses={"!px-0 !h-auto !bg-transparent !rounded-none"}
          buttonHasLink={true}
          buttonLink={"/login"}
          buttonLabel={"Login page"}
          buttonLabelClasses={"hover:!underline"}
          buttonStyles={{
            color: site?.highlight_color,
          }}
        />
      </div>
    </div>
  );

  return (
    <AuthDataLayout
      title="Send a reset link"
      subTitle="Enter your sign up email and we'll take care of the rest"
      LinkUpComponent={LinkUpComponent}>
      <form
        className="flex w-full flex-col"
        id="loginform"
        action="/portal/auth-login"
        method="post">
        <div className="flex w-full flex-col gap-y-3">
          <div className="w-full">
            <Input
              inline={true}
              inputValue={email}
              labelClasses={"font-medium"}
              label={"Email"}
              inputType={"email"}
              inputName={"email"}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>
        <div className="mt-4 grid gap-y-4">
          <Button
            isDisable={verifiingUser}
            loading={verifiingUser}
            success={userVerified}
            buttonClasses={"w-full"}
            buttonType={"submit"}
            buttonIcon={EnvelopeIcon}
            buttonIconPosition="left"
            buttonLabel={verifiingUser ? "Sending..." : userVerified ? "Sent" : "Send reset link"}
            buttonStyles={{
              borderColor: site?.highlight_color,
              backgroundColor: site?.highlight_color,
            }}
            buttonLabelClasses={"!text-sm !font-medium"}
            buttonFunction={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          />
        </div>
      </form>
    </AuthDataLayout>
  );
};

export default ForgotPassword;
